import { createSlice } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

const initialState = {
  start: DateTime.now().startOf('day').minus({ weeks: 4 }).toUTC().toMillis(),
  end: DateTime.now().endOf('day').minus({ days: 1 }).toUTC().toMillis(),
};

const timeRangeSlice = createSlice({
  name: 'timeRange',
  initialState,
  reducers: {
    setTimeRange(state, action) {
      state.start = action.payload.start;
      state.end = action.payload.end;
    },
    setTimeRangeDT(state, action) {
      const { start, end } = action.payload;
      if (!DateTime.isDateTime(start) || !DateTime.isDateTime(end)) {
        throw new Error('start and end must be Luxon DateTime instances');
      }
      state.start = start.toMillis();
      state.end = end.toMillis();
    },
  },
});

export const { setTimeRange, setTimeRangeDT } = timeRangeSlice.actions;

export default timeRangeSlice.reducer;

// Selector to get the whole time range
export const selectTimeRange = (state) => state.timeRange;

// Selector to get just the start
export const selectStart = (state) => state.timeRange.start;

// Selector to get just the end
export const selectEnd = (state) => state.timeRange.end;

// Selector to get the time range in DateTime format.
export const selectTimeRangeDT = (state) => ({
  start: DateTime.fromMillis(state.timeRange.start),
  end: DateTime.fromMillis(state.timeRange.end),
});
